import { render, staticRenderFns } from "./ModalForCreatingPreformedPanels.vue?vue&type=template&id=4da30a88&"
import script from "./ModalForCreatingPreformedPanels.vue?vue&type=script&lang=js&"
export * from "./ModalForCreatingPreformedPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports